// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Hy-z","imageAndVideoCount":"Iy-z","imageAndVideoContainer":"Jy-z","viewAllReviews":"Ky-z"};